














import { Vue, Component } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: { NewTranslation, Button },
})
export default class SelectPrintModePage extends Vue {}
